'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = dynamicSidebarReducer;

var _immutable = require('immutable');

var _DynamicSidebarActionTypes = require('../actionTypes/DynamicSidebarActionTypes');

var INITIAL_STATE = null;

function dynamicSidebarReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _DynamicSidebarActionTypes.UPDATE_SIDEBAR:
      if (!state) {
        state = new _immutable.Map({
          image: null,
          title: null,
          text: null,
          url: null,
          transition: true
        });
      }

      if (payload === null) {
        return payload;
      }

      return state = new _immutable.Map({
        image: payload.image,
        title: payload.title,
        text: payload.text,
        url: payload.url,
        transition: payload.transition !== undefined ? payload.transition : true
      });
    default:
      return state;
  }
}
module.exports = exports['default'];